import { validateCapsuleTopology } from "../../pages/Admin/Dashboard/roomClassification";

export const TEACHER_ROLE_ID = 4;

const hasTeacherBackedPace = (envelope) =>
  envelope?.expected_pace !== null &&
  typeof envelope?.expected_pace === "object" &&
  !Array.isArray(envelope.expected_pace);

const contextMatches = (context, envelope) =>
  String(context?.cohort_id) === String(envelope?.cohort?.id) &&
  String(context?.challenge_id) === String(envelope?.challenge?.id);

export const evaluatePaceWriteEligibility = ({
  envelope,
  contexts,
  facilitatorRoleId,
}) => {
  const topology = validateCapsuleTopology(envelope?.capsules);
  const serviceableContexts = Array.isArray(contexts) ? contexts : [];
  const roomResolved =
    envelope?.cohort?.id != null && envelope?.challenge?.id != null;

  let reason = null;
  if (!hasTeacherBackedPace(envelope))
    reason = "no teacher-backed pace setting is available";
  else if (Number(facilitatorRoleId) !== TEACHER_ROLE_ID)
    reason = "only the room's teacher can change expected pace";
  else if (serviceableContexts.length === 0)
    reason = "pace stays read only until one room is available";
  else if (serviceableContexts.length > 1)
    reason = "pace stays read only while several rooms are available";
  else if (!roomResolved || !contextMatches(serviceableContexts[0], envelope))
    reason = "the current room could not be matched safely";
  else if (!topology.valid)
    reason = "the challenge levels could not be resolved safely";

  return { allowed: reason === null, reason, topology };
};

export const paceCandidate = (pace, topology) => {
  const levels = new Set(
    (topology?.valid ? topology.capsules : []).map(
      (capsule) => capsule.levelNumber,
    ),
  );
  if (levels.has(pace?.storedLevel)) return pace.storedLevel;
  if (levels.has(pace?.resolvedLevel)) return pace.resolvedLevel;
  return null;
};

export const candidateIsPersisted = (candidate, pace) =>
  candidate !== null && Number(candidate) === Number(pace?.storedLevel);
